import api from '../utils/interceptor';
const API_URL = process.env.REACT_APP_API_URL;


// Create creating payment Service
export const createPaymentService = async (data) => {
    try {
        const response = await api.post(API_URL + 'create-payment', data);
        return response;
    } catch (error) {
        console.error('Error creating create payment :', error);
        throw error;
    }
};


